import { createBox } from "@shopify/restyle";
import React, {
  ComponentPropsWithoutRef,
  CSSProperties,
  forwardRef,
} from "react";

import { Theme } from "../../../theme/restyle/theme";

type WebBoxStyle = CSSProperties | false | null | undefined | WebBoxStyle[];

type WebBoxBaseProps = Omit<ComponentPropsWithoutRef<"div">, "style"> & {
  style?: WebBoxStyle;
};

const mergeStyle = (mergedStyle: CSSProperties, style?: WebBoxStyle): void => {
  if (!style) {
    return;
  }

  if (Array.isArray(style)) {
    style.forEach((styleValue) => mergeStyle(mergedStyle, styleValue));
    return;
  }

  Object.assign(mergedStyle, style);
};

const flattenStyle = (style?: WebBoxStyle): CSSProperties | undefined => {
  if (!style) {
    return undefined;
  }

  const mergedStyle: CSSProperties = {};

  mergeStyle(mergedStyle, style);
  return mergedStyle;
};

const WebBoxBase = forwardRef<HTMLDivElement, WebBoxBaseProps>(
  ({ style, ...props }, ref) => (
    <div ref={ref} style={flattenStyle(style)} {...props} />
  )
);

WebBoxBase.displayName = "WebBoxBase";

export const WebBox = createBox<Theme, WebBoxBaseProps>(WebBoxBase);
